@if (details.nocCode) {
    <section class="noc-info">
        <h3 class="noc-info__heading">Notification of Change (NOC)</h3>
        <div class="noc-info__grid">
            <div>
                <span class="noc-info__label">NOC Date</span>
                <p class="noc-info__value">{{ details.nocDate | date:'MM/dd/yyyy' }}</p>
            </div>
            <div>
                <span class="noc-info__label">NOC Reason Code</span>
                <p class="noc-info__value">{{ details.nocCode }}</p>
            </div>
            <div>
                <span class="noc-info__label">NOC Description</span>
                <p class="noc-info__value">{{ details.nocDescription }}</p>
            </div>
        </div>
    </section>
}
